import { type FC, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { ChromePicker } from 'react-color';
import { colorPicker } from './styles';

interface Props {
	coords: any;
	defaultColor: string;
	onChangeComplete: (_) => void;
	onClickOutside: () => void;
}

const ColorPickerDropdown: FC<Props> = (props) => {
	const { coords, defaultColor, onChangeComplete, onClickOutside } = props;

	const [color, setColor] = useState(defaultColor);
	const ref = useRef(null);

	const handleColorChange = (color, event) => {
		setColor(color.hex);
	};

	const handleChangeComplete = (color, event) => onChangeComplete(color.hex);

	const handleClickOutside = (event) => {
		if (ref.current && !ref.current.contains(event.target)) {
			onClickOutside();
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	});

	return ReactDOM.createPortal(
		<div className={colorPicker} style={{ top: coords.top, left: coords.left }} ref={ref}>
			<ChromePicker
				color={color}
				disableAlpha={true}
				onChange={handleColorChange}
				onChangeComplete={handleChangeComplete}
			/>
		</div>,
		document.querySelector('#editor2-portal-root')
	);
};

export default ColorPickerDropdown;
